import { createContext, useContext, useState, useEffect } from 'react';
import {
    fetchAssetCategory,
    fetchAssetCondition,
    fetchAssetType,
    fetchAssetDepMethod,
    fetchAssetMasters,
    fetchAssignedAsset,
    fetchServiceAsset,
    fetchAssetStatus
} from '../../Api/assetMaster'; // Update path as needed

const AssetContext = createContext();

export const AssetProvider = ({ children }) => {
    const [assetCatTypes, setAssetCatTypes] = useState([]);
    const [assetConTypes, setAssetConTypes] = useState([]);
    const [assetTypes, setAssetTypes] = useState([]);
    const [deprecMethod, setDeprecMethod] = useState([]);
    const [fetchAssetData, setFetchAssetData] = useState([]);
    const [assignedAsset, setAssignedAsset] = useState([]);
    const [serviceAsset, setServiceAsset] = useState([]);
    const [assetStatus, setAssetStatus] = useState([]);



    const loadCatTypes = async () => {
        try {
            const data = await fetchAssetCategory();
            // console.log(data, 'data of body types')
            setAssetCatTypes(data);
        } catch (error) {
            console.error('Failed to fetch categories:', error);
        }
    };

    const loadConTypes = async () => {
        try {
            const data = await fetchAssetCondition();
            // console.log(data, 'data of body types')
            setAssetConTypes(data);
        } catch (error) {
            console.error('Failed to fetch categories:', error);
        }
    };

    const loadAssetTypes = async () => {
        try {
            const data = await fetchAssetType();
            // console.log(data, 'data of body types')
            setAssetTypes(data);
        } catch (error) {
            console.error('Failed to fetch categories:', error);
        }
    };

    const loadDeprecMethod = async () => {
        try {
            const data = await fetchAssetDepMethod();
            // console.log(data, 'data of body types')
            setDeprecMethod(data);
        } catch (error) {
            console.error('Failed to fetch categories:', error);
        }
    };

    const loadAssetMaster = async () => {
        try {
            const data = await fetchAssetMasters();
            // console.log(data, 'data of body types')
            setFetchAssetData(data);
        } catch (error) {
            console.error('Failed to fetch categories:', error);
        }
    };

    const loadAssignedAsset = async () => {
        try {
            const data = await fetchAssignedAsset();
            // console.log(data, 'data of body types')
            setAssignedAsset(data);
        } catch (error) {
            console.error('Failed to fetch categories:', error);
        }
    };

    const loadAssetService = async () => {
        try {
            const data = await fetchServiceAsset();
            // console.log(data, 'data of body types')
            setServiceAsset(data);
        } catch (error) {
            console.error('Failed to fetch categories:', error);
        }
    };

     const loadAssetStatus = async () => {
        try {
            const data = await fetchAssetStatus();
            // console.log(data, 'data of body types')
            setAssetStatus(data);
        } catch (error) {
            console.error('Failed to fetch categories:', error);
        }
    };

    // Fetch subcategories when category changes

    return (
        <AssetContext.Provider
            value={{
                assetCatTypes,
                loadCatTypes,
                assetConTypes,
                loadConTypes,
                assetTypes,
                loadAssetTypes,
                deprecMethod,
                loadDeprecMethod,
                fetchAssetData,
                loadAssetMaster,
                assignedAsset,
                loadAssignedAsset,
                serviceAsset,
                loadAssetService,
                assetStatus,
                loadAssetStatus
            }}
        >
            {children}
        </AssetContext.Provider>
    );
};

export const useAssetContext = () => useContext(AssetContext);